"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The MediaSource model module.
 * @module model/MediaSource
 * @version 3.0
 */
var MediaSource = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>MediaSource</code>.
   * @alias module:model/MediaSource
   */
  function MediaSource() {
    _classCallCheck(this, MediaSource);
    MediaSource.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(MediaSource, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>MediaSource</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MediaSource} obj Optional instance to populate.
     * @return {module:model/MediaSource} The populated <code>MediaSource</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new MediaSource();
        if (data.hasOwnProperty('sourceType')) {
          obj['sourceType'] = _ApiClient["default"].convertToType(data['sourceType'], 'String');
        }
        if (data.hasOwnProperty('container')) {
          obj['container'] = _ApiClient["default"].convertToType(data['container'], 'String');
        }
        if (data.hasOwnProperty('duration')) {
          obj['duration'] = _ApiClient["default"].convertToType(data['duration'], 'Number');
        }
        if (data.hasOwnProperty('codec')) {
          obj['codec'] = _ApiClient["default"].convertToType(data['codec'], 'String');
        }
        if (data.hasOwnProperty('bitRate')) {
          obj['bitRate'] = _ApiClient["default"].convertToType(data['bitRate'], 'Number');
        }
        if (data.hasOwnProperty('fileSize')) {
          obj['fileSize'] = _ApiClient["default"].convertToType(data['fileSize'], 'Number');
        }
        if (data.hasOwnProperty('screenWidth')) {
          obj['screenWidth'] = _ApiClient["default"].convertToType(data['screenWidth'], 'Number');
        }
        if (data.hasOwnProperty('screenHeight')) {
          obj['screenHeight'] = _ApiClient["default"].convertToType(data['screenHeight'], 'Number');
        }
        if (data.hasOwnProperty('link')) {
          obj['link'] = _ApiClient["default"].convertToType(data['link'], 'String');
        }
        if (data.hasOwnProperty('profiles')) {
          obj['profiles'] = _ApiClient["default"].convertToType(data['profiles'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MediaSource</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaSource</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['sourceType'] && !(typeof data['sourceType'] === 'string' || data['sourceType'] instanceof String)) {
        throw new Error("Expected the field `sourceType` to be a primitive type in the JSON string but got " + data['sourceType']);
      }
      // ensure the json data is a string
      if (data['container'] && !(typeof data['container'] === 'string' || data['container'] instanceof String)) {
        throw new Error("Expected the field `container` to be a primitive type in the JSON string but got " + data['container']);
      }
      // ensure the json data is a string
      if (data['codec'] && !(typeof data['codec'] === 'string' || data['codec'] instanceof String)) {
        throw new Error("Expected the field `codec` to be a primitive type in the JSON string but got " + data['codec']);
      }
      // ensure the json data is a string
      if (data['link'] && !(typeof data['link'] === 'string' || data['link'] instanceof String)) {
        throw new Error("Expected the field `link` to be a primitive type in the JSON string but got " + data['link']);
      }
      // ensure the json data is a string
      if (data['profiles'] && !(typeof data['profiles'] === 'string' || data['profiles'] instanceof String)) {
        throw new Error("Expected the field `profiles` to be a primitive type in the JSON string but got " + data['profiles']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} sourceType
 */
MediaSource.prototype['sourceType'] = undefined;

/**
 * @member {String} container
 */
MediaSource.prototype['container'] = undefined;

/**
 * @member {Number} duration
 */
MediaSource.prototype['duration'] = undefined;

/**
 * @member {String} codec
 */
MediaSource.prototype['codec'] = undefined;

/**
 * @member {Number} bitRate
 */
MediaSource.prototype['bitRate'] = undefined;

/**
 * @member {Number} fileSize
 */
MediaSource.prototype['fileSize'] = undefined;

/**
 * @member {Number} screenWidth
 */
MediaSource.prototype['screenWidth'] = undefined;

/**
 * @member {Number} screenHeight
 */
MediaSource.prototype['screenHeight'] = undefined;

/**
 * @member {String} link
 */
MediaSource.prototype['link'] = undefined;

/**
 * @member {String} profiles
 */
MediaSource.prototype['profiles'] = undefined;
var _default = exports["default"] = MediaSource;